<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <component
      :is="component"
      :ref="sharedRefs"
      :shareUrlInfo="linkData"
    ></component>
  </v-dialog>
</template>

<script>
/*eslint-disable */
import SharedMar from "@/components/medications/MAR/SharedMar";
import SharedAdl from "@/components/serviceplan/adl/SharedAdl";
import { mapActions } from "vuex";

export default {
  components: {
    mar: SharedMar,
    adl: SharedAdl,
  },
  data() {
    return {
      dialog: true,
      path: "",
      show: false,
      component: "",
      sharedRefs: "",
      linkData: "",
      sharedPath: ["mar", "adl"],
    };
  },

  created() {
    this.validateURL();
  },

  mounted() {
    this.path = this.$route.params.path;
  },

  methods: {
    ...mapActions({
      getLinkInfo: "shareLink/getLinkInfo",
    }),

    async validateURL() {
      let code = this.$route.query.code;
      let response = await this.getLinkInfo(code);
      if (!response.success) {
        return this.$router.push({ name: "LinkError" });
      }
      const { shareUrlInfo } = response.url;
      this.linkData = shareUrlInfo;
      this.getLinkData();
    },
    getLinkData() {
      for (let i = 0; i < this.sharedPath.length; i++) {
        const path = this.sharedPath[i];
        if (this.path === path) {
          this.component = path;
          this.sharedRefs = path;
          this.$nextTick(() => {
            this.$refs[path].getSharedLink();
          });
        }
      }
    },
    clear() {
      this.dialog = false;
      this.$router.push();
    },
  },
};
</script>
